const STORAGE_KEY = 'openbro_attr';
const GEO_CODES = new Set(['ca', 'us', 'fr', 'uk', 'gb']);

function readStored() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
  } catch {
    return null;
  }
}

export function sessionId() {
  let sid = sessionStorage.getItem('openbro_sid');
  if (!sid) {
    sid = crypto.randomUUID();
    sessionStorage.setItem('openbro_sid', sid);
  }
  return sid;
}

function derive(raw) {
  const term = String(raw.term || '').toLowerCase();
  const content = String(raw.content || '').toLowerCase();
  let audience = '';
  let creative = raw.content || '';
  if (GEO_CODES.has(term)) {
    audience = term === 'gb' ? 'uk' : term;
  } else if (GEO_CODES.has(content)) {
    audience = content === 'gb' ? 'uk' : content;
    creative = '';
  }
  return {
    source: raw.source || '',
    medium: raw.medium || '',
    campaign: raw.campaign || '',
    creative,
    audience,
    landing: raw.landing || '/',
    firstAt: raw.firstAt || Date.now(),
    sid: raw.sid || sessionId(),
  };
}

/** Première provenance gagnante : un clic pub plus tard ne l'écrase pas. */
export function captureAttribution() {
  const stored = readStored();
  const params = new URLSearchParams(window.location.search);
  const incoming = {
    source: params.get('utm_source') || '',
    medium: params.get('utm_medium') || '',
    campaign: params.get('utm_campaign') || '',
    content: params.get('utm_content') || '',
    term: params.get('utm_term') || '',
  };
  const hasUtm = Object.values(incoming).some(Boolean);
  if (stored?.source && !hasUtm) return { ...stored, sid: sessionId() };
  if (stored?.source && hasUtm && stored.locked) return { ...stored, sid: sessionId() };
  const attr = derive({
    ...incoming,
    landing: `${window.location.pathname}${window.location.search}`.slice(0, 180),
    firstAt: stored?.firstAt || Date.now(),
    sid: sessionId(),
  });
  attr.locked = Boolean(attr.source);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(attr));
  } catch {
    // navigation privée
  }
  const ph = window.posthog;
  if (ph && typeof ph.register === 'function') {
    ph.register({
      source: attr.source,
      campaign: attr.campaign,
      creative: attr.creative,
      audience: attr.audience,
    });
  }
  return attr;
}

export function trackStep(step, extra = {}) {
  const attr = captureAttribution();
  const payload = {
    step,
    sid: attr.sid,
    source: attr.source,
    medium: attr.medium,
    campaign: attr.campaign,
    creative: attr.creative,
    audience: attr.audience,
    landing: attr.landing,
    button: extra.button || '',
    page: window.location.pathname,
  };
  fetch('/api/analytics/funnel-event', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {});
  const ph = window.posthog;
  if (ph && typeof ph.capture === 'function') ph.capture(step, payload);
}
